'use strict';

var AbstractFormView = require('components/common/views/abstract_form_view');
var Bookmark = require('models/bookmark').Bookmark;
var Consts = require('consts');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Validator = require('utils/validation');

const MaxCharCount = 500;

var BookmarkDialogView = AbstractFormView.extend({
    template: require('components/common/templates/bookmark_dialog'),
    ui: {
        save: '#js-save',
        delete: '#js-delete',
        isPublic: '#js-public-input',
        name: '#js-name-input',
        description: '#js-description-input',
    },

    events: function () {
        return _.extend({}, AbstractFormView.prototype.events, {
            'click @ui.save': 'saveConfiguration',
            'click @ui.delete': 'deleteConfiguration',
        });
    },

    initialize: function (options) {
        this.nameIsDuplicate = false;
        this.name = this.options.bookmark.get('name') || '';
        this.description = this.options.bookmark.get('description');
        this.public = this.options.bookmark.get('public');
        this.id = this.options.bookmark.id;
        AbstractFormView.prototype.initialize.apply(this, [
            {
                inputFields: {
                    'js-name': {
                        method: 'callback',
                        validationCB: function (val) {
                            return Validator.validateText(val.trim(), 1).length === 0;
                        },
                    },
                },
                errors: options.errors,
                formData: options.formData,
                cleanHook: this.updateDuplicateHint,
            },
        ]);
    },

    serializeData: function () {
        var bm = this.options.bookmark.attributes;
        var saveButtonName = bm.id ? i18n.TR('Überschreiben') : i18n.TR('Speichern');

        var info = {
            type: 'info',
            text: i18n.TR('Es gibt bereits ein Lesezeichen mit diesem Namen.'),
        };
        return {
            name: this.name,
            isNew: this.id == 0 || this.id == undefined,
            description: this.description,
            public: this.public,
            saveButtonName: saveButtonName,
            userCanEditPublic: this.options.userCanEditPublic,
            nameIsDuplicate: this.nameIsDuplicate,
            info: info,
        };
    },

    onRender: function () {
        Misc.initSelectPicker();
    },

    onShow: function () {
        Misc.initSelectPicker();
    },

    updateDuplicateHint: function (e) {
        var nameChanged = this.name != this.ui.name.val();
        this.name = this.ui.name.val();
        this.nameIsDuplicate = this.isDuplicate(this.name);

        // persist content of other fields to not loose them after render
        this.description = this.ui.description.val();
        this.public = this.ui.isPublic.is(':checked');
        if (nameChanged) {
            this.selectionStart = this.ui.name[0].selectionStart;
            this.render();
            // restore cursor position and focus after render
            this.ui.name.focus();
            this.ui.name[0].selectionStart = this.selectionStart;
        }
    },

    isDuplicate: function (name) {
        var val = this.ui.name.val();
        var id = this.id;
        return (
            this.options.collection.find(function (m) {
                return m.get('name') === val && m.id != id;
            }) != undefined
        );
    },

    deleteConfiguration: function () {
        var self = this;
        this.options.bookmark.destroy({
            success: function (model) {
                self.options.collection.remove(self.options.bookmark.id);
                self.options.callback('delete', true, model.id);
            },
            error: function (model, response) {
                var errorMessage = '';
                if (response && response.responseText) {
                    errorMessage = response.responseText.trim();
                }
                self.options.callback('delete', false, model.id, errorMessage, response.status);
            },
        });
    },

    saveConfiguration: function () {
        if (this.allFieldsValid()) {
            var bm = this.options.bookmark;
            var isPublic = this.ui.isPublic.is(':checked') && this.options.userCanEditPublic;

            var category = Misc.getDeviceCategoryFromURL();
            var self = this;
            bm.save(
                {
                    name: this.ui.name.val(),
                    public: isPublic,
                    page: 'charts',
                    description: this.ui.description.val(),
                    category: category,
                    pageConfiguration: JSON.stringify(this.options.configuration),
                },
                {
                    success: function (model) {
                        model.attributes.pageConfiguration = JSON.parse(model.attributes.pageConfiguration);
                        self.options.collection.set(model, { remove: false });
                        self.options.callback('save', true, model.id);
                    },
                    error: function (model, response, error) {
                        var errorMessage = '';
                        if (response && response.responseText) {
                            errorMessage = response.responseText.trim();
                        }
                        self.options.callback('save', false, model.id, errorMessage, response.status);
                    },
                }
            );
        }
    },
});

module.exports = BookmarkDialogView;
